import { combineReducers } from 'redux'
import { createReducer } from 'redux-create-reducer'
import { createResponsiveStateReducer } from 'redux-responsive'
import { reducer as form } from 'redux-form'
import URLSearchParams from 'url-search-params'
import Cookies from 'js-cookie'

import searchFilters from '../../search/reducers/searchFilters'
import secondStep from '../../secondStep/reducers/secondStep'
import formLogin from '../../secondStep/reducers/formLogin'
import {
  SEARCH_PARAM_KEYWORD,
  SEARCH_PARAM_HOTEL_DIRECT_ID,
  TestAdagioABQA_HOTELPAGE_right,
} from '../../search/constants'
import globalLoader from '../../loader/reducers/loaderReducer'
import conditionsReducer from '../../firstStep/reducers/conditionsReducer'
import imagesReducer from "../../../scenes/GalleryPopup/reducers/imagesReducer";
import familyFriendlyReducer from "../../PopupConstructor/popups/FamilyFriendlyPopup/reducers/familyFriendlyReducer";
import popup from '../../PopupConstructor/reducers/popupReducer'
import extendedReviews from './reviews'
import kontoroRedux, {KONTORO_KEY} from 'js/utils/kontorolab/redux'

export const SMALL = 'small'
export const EXTRA_SMALL = 'extraSmall'
export const MEDIUM = 'medium'
export const LARGE = 'large'
export const EXTRA_LARGE = 'extraLarge'

export const UPDATE_STORE_VALUE = 'SearchResults.UPDATE_STORE_VALUE'

const env = window.drupalSettings?.bookingBlock?.url

const getSearchResultsKeyword = () => {
  let keyword = ''
  const searchParams = new URLSearchParams(window.location.search)
  if (searchParams.has(SEARCH_PARAM_KEYWORD)) {
    keyword = searchParams.get(SEARCH_PARAM_KEYWORD)
  } else if (searchParams.has(SEARCH_PARAM_HOTEL_DIRECT_ID)) {
    keyword = searchParams.get(SEARCH_PARAM_HOTEL_DIRECT_ID)
  }
  return keyword
}

const checkCookieHotelPageABtestyRight = () => {
  return !!(Cookies.get(TestAdagioABQA_HOTELPAGE_right) || Cookies.get(TestAdagioABQA_HOTELPAGE_right) === '')
}

const initialState = {
  pageIndex: null,
  setting: window.drupalSettings,
  results: [],
  searchResultsKeyword: getSearchResultsKeyword(),
  searchUrlHolder: '',
  searchUrlFiltersHolder: '',
  holdKeyword: '',
  basketHashUpdated: null,
  bookingUrl: '',
  homePageVideoBanner: true,
  homePageABtestySearch: true,
  hotelAccordion: {},
  hotelBookingABTesty: {
    right: checkCookieHotelPageABtestyRight() && env !== 'https://www.adagio-city.com',
  },
}

const main = createReducer(initialState, {
  [UPDATE_STORE_VALUE](state, { key, value }) {
    return key ? { ...state, [key]: typeof value === 'function' ? value(state[key]) : value } : { ...state, ...value }
  },
})


const browser = createResponsiveStateReducer({
  [EXTRA_SMALL]: 567,
  [SMALL]: 767,
  [MEDIUM]: 1023,
  [LARGE]: 1299,
  [EXTRA_LARGE]: 1279,
})


export default combineReducers({
  main,
  browser,
  globalLoader,
  extendedReviews,
  conditions: conditionsReducer,
  galleryPopup: imagesReducer,
  familyFriendlyPopup: familyFriendlyReducer,
  popup,
  [KONTORO_KEY]: kontoroRedux.reducers,
  form: form.plugin({
    searchFilters,
    secondStep,
    formLogin,
  }),
})
